
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, anonRecord_type, bool_type, class_type, record_type, list_type, option_type, float64_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName, Receiver_$reflection } from "../../Shared/User.js";
import { FormState__getValidation, FormState__startLoading, StorageId, FormState__setValidationResponse_5219762A, ToolId__get_unwrap, RequestedValue$1, FormState_get_empty, TokenDataDto_$reflection, CustomerConfiguration_$reflection, RequestedValue$1_$reflection, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { Helper_unitToTranslationKey, Consumable_$reflection } from "../../Shared/Consumable.js";
import { ToolTypes_$reflection } from "../../Shared/Tool.js";
import { Storage_$reflection } from "../../Shared/Storage.js";
import { ToolWithQuantityReservation, ConsumableReservation, MultiReservationCreateDto, MultiReservationCreateDto_$reflection } from "../../Shared/MultiOperation.js";
import { sortBy, toArray as toArray_1, length, exists, append as append_1, tryHead, contains, tryFind, filter, cons, find, ofArray, map, singleton as singleton_1, empty, isEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { compare, utcNow } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { iterate, toArray, empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { getSelectedSets } from "../../Requests/Set.js";
import { getSelectedConsumables } from "../../Requests/Consumable.js";
import { Cmd_getSelectedTools } from "../../Requests/Tool.js";
import { fetchWithDecoder as fetchWithDecoder_1, addPrefix as addPrefix_1 } from "../../CommunicationV2.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { toArray as toArray_2, unwrap, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { unwrapConsumableId, unwrapStorageId } from "../../Shared/Helper.js";
import { comparePrimitives, createObj, stringHash, safeHash, equals } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { parse, newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { numberInputIntMaxValue, toISOString } from "../../Common.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FSharpMap__get_IsEmpty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { InvalidTextValue } from "../../Components/Text.js";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { AutoSuggestInput, NumberInput } from "../../Components/Input.js";
import { GroupedSelect, Select } from "../../Components/Select.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { TabsMenu } from "../TabsMenu.js";
import { TableControl$1, Table as Table_1 } from "../Table/Table.js";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { InformationAlert } from "../../Components/Alert.js";
import { DatePicker } from "../../Components/DatePicker.js";
import { TextArea } from "../../Components/TextArea.js";
import { Button } from "../../Components/Button.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

export class TableElementType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Consumable", "Set"];
    }
}

export function TableElementType_$reflection() {
    return union_type("Widgets.Modals.MultiReservationModal.TableElementType", [], TableElementType, () => [[], [], [], []]);
}

export class TableElement extends Record {
    constructor(Id, ElementId, Manufacturer, Model, Name, AdditionalName, InventoryNumber, Quanity, Type, Unit, SelectedStorageId, AvailableStorageIds) {
        super();
        this.Id = Id;
        this.ElementId = ElementId;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.InventoryNumber = InventoryNumber;
        this.Quanity = Quanity;
        this.Type = Type;
        this.Unit = Unit;
        this.SelectedStorageId = SelectedStorageId;
        this.AvailableStorageIds = AvailableStorageIds;
    }
}

export function TableElement_$reflection() {
    return record_type("Widgets.Modals.MultiReservationModal.TableElement", [], TableElement, () => [["Id", string_type], ["ElementId", string_type], ["Manufacturer", string_type], ["Model", string_type], ["Name", string_type], ["AdditionalName", string_type], ["InventoryNumber", string_type], ["Quanity", option_type(float64_type)], ["Type", TableElementType_$reflection()], ["Unit", string_type], ["SelectedStorageId", option_type(string_type)], ["AvailableStorageIds", list_type(string_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Assign", "SetStartDate", "SetEndDate", "SetNotifiyReceiver", "SetName", "SetDescription", "SetQuantity", "SetStorage", "SetSelectedReceiver", "AddElement", "RemoveElement", "InitTableElements", "ReservationResponse", "SetsFetched", "ConsumableFetched", "ToolsFetched", "ReceiversFetched", "StoragesFetched", "ReservationNameSuggestionsFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Modals.MultiReservationModal.Msg", [], Msg, () => [[], [["Item", class_type("System.DateTime")]], [["Item", class_type("System.DateTime")]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["id", string_type], ["quantity", option_type(float64_type)]], [["id", string_type], ["storageId", option_type(string_type)]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))]], [["id", string_type]], [["id", string_type]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(DataTransfer_DetailSet_$reflection())]], [["Item", list_type(Consumable_$reflection())]], [["Item", list_type(ToolTypes_$reflection())]], [["Item", list_type(Receiver_$reflection())]], [["Item", list_type(Storage_$reflection())]], [["Item", list_type(string_type)]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(FormState, SuccessCallback, OnClose, Receivers, Sets, Consumables, Storages, Tools, TableElements, RemovedElements, Dto, NameSuggestions, CustomerConfiguration, UserData, StartDate, EndDate) {
        super();
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.Receivers = Receivers;
        this.Sets = Sets;
        this.Consumables = Consumables;
        this.Storages = Storages;
        this.Tools = Tools;
        this.TableElements = TableElements;
        this.RemovedElements = RemovedElements;
        this.Dto = Dto;
        this.NameSuggestions = NameSuggestions;
        this.CustomerConfiguration = CustomerConfiguration;
        this.UserData = UserData;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
    }
}

function State_$reflection() {
    return record_type("Widgets.Modals.MultiReservationModal.State", [], State, () => [["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["Sets", RequestedValue$1_$reflection(list_type(DataTransfer_DetailSet_$reflection()))], ["Consumables", RequestedValue$1_$reflection(list_type(Consumable_$reflection()))], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["Tools", RequestedValue$1_$reflection(list_type(ToolTypes_$reflection()))], ["TableElements", list_type(TableElement_$reflection())], ["RemovedElements", list_type(TableElement_$reflection())], ["Dto", MultiReservationCreateDto_$reflection()], ["NameSuggestions", list_type(string_type)], ["CustomerConfiguration", CustomerConfiguration_$reflection()], ["UserData", TokenDataDto_$reflection()], ["StartDate", class_type("System.DateTime")], ["EndDate", class_type("System.DateTime")]]);
}

function init(successCallback, onClose, userData, customerConfiguration, reservationProps) {
    return [new State(FormState_get_empty(), successCallback, onClose, new RequestedValue$1(0, []), isEmpty(reservationProps.SetIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), isEmpty(reservationProps.ConsumableIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), new RequestedValue$1(0, []), isEmpty(reservationProps.ToolIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), empty(), empty(), new MultiReservationCreateDto("", "", "", "", false, "", empty(), empty(), empty(), empty()), empty(), customerConfiguration, userData, utcNow(), utcNow()), Cmd_batch(toList(delay(() => append(singleton(Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(string_type)));
    })))), "/api/tools/reservations/name-suggestions", (Item) => (new Msg(18, [Item])), (Item_1) => (new Msg(19, [Item_1])))), delay(() => append(!isEmpty(reservationProps.SetIds) ? singleton(getSelectedSets(reservationProps.SetIds, (Item_2) => (new Msg(13, [Item_2])), (Item_3) => (new Msg(19, [Item_3])))) : empty_1(), delay(() => append(!isEmpty(reservationProps.ConsumableIds) ? singleton(getSelectedConsumables(reservationProps.ConsumableIds, (Item_4) => (new Msg(14, [Item_4])), (Item_5) => (new Msg(19, [Item_5])))) : empty_1(), delay(() => append(!isEmpty(reservationProps.ToolIds) ? singleton(Cmd_getSelectedTools(map(ToolId__get_unwrap, reservationProps.ToolIds), (Item_6) => (new Msg(15, [Item_6])), (Item_7) => (new Msg(19, [Item_7])))) : empty_1(), delay(() => {
        let businessUnitId;
        return append(singleton((businessUnitId = undefined, Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_5;
            return ((url_5 = addPrefix_1(url_3), (refreshOn) => fetchWithDecoder_1(url_5, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_1) => {
                const pr_1 = response_1.arrayBuffer();
                return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Receiver_$reflection())));
            }, refreshOn)))(true).then((_arg) => {
                const result_2 = _arg;
                return (result_2.tag === 1) ? (Promise.resolve((() => {
                    throw new ValidationOnGetRequest(result_2.fields[0]);
                })())) : (Promise.resolve(result_2.fields[0]));
            });
        })), concat("/api/receivers/active", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item_8) => (new Msg(16, [Item_8])), (Item_9) => (new Msg(19, [Item_9]))))), delay(() => singleton(Cmd_OfPromise_either((url_6) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url_6), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_2 = response_2.arrayBuffer();
            return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), list_type(Storage_$reflection())));
        })))), "/api/storages", (Item_10) => (new Msg(17, [Item_10])), (Item_11) => (new Msg(19, [Item_11]))))));
    })))))))))))];
}

function update(msg, state) {
    let bind$0040_1, bind$0040_2, bind$0040_3, bind$0040_4, matchValue_6, ownReceiver;
    switch (msg.tag) {
        case 12: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 7:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, map((tableElement) => {
                if (tableElement.Id === msg.fields[0]) {
                    return new TableElement(tableElement.Id, tableElement.ElementId, tableElement.Manufacturer, tableElement.Model, tableElement.Name, tableElement.AdditionalName, tableElement.InventoryNumber, tableElement.Quanity, tableElement.Type, tableElement.Unit, msg.fields[1], tableElement.AvailableStorageIds);
                }
                else {
                    return tableElement;
                }
            }, state.TableElements), state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
        case 6:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, map((tableElement_1) => {
                if (tableElement_1.Id === msg.fields[0]) {
                    return new TableElement(tableElement_1.Id, tableElement_1.ElementId, tableElement_1.Manufacturer, tableElement_1.Model, tableElement_1.Name, tableElement_1.AdditionalName, tableElement_1.InventoryNumber, msg.fields[1], tableElement_1.Type, tableElement_1.Unit, tableElement_1.SelectedStorageId, tableElement_1.AvailableStorageIds);
                }
                else {
                    return tableElement_1;
                }
            }, state.TableElements), state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
        case 5:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_1 = state.Dto, new MultiReservationCreateDto(msg.fields[0], bind$0040_1.Name, bind$0040_1.StartDate, bind$0040_1.EndDate, bind$0040_1.NotifyUser, bind$0040_1.ReceiverId, bind$0040_1.ConsumableReservations, bind$0040_1.ToolWithQuantityReservations, bind$0040_1.SetIds, bind$0040_1.ToolIds)), state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
        case 3:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_2 = state.Dto, new MultiReservationCreateDto(bind$0040_2.Description, bind$0040_2.Name, bind$0040_2.StartDate, bind$0040_2.EndDate, msg.fields[0], bind$0040_2.ReceiverId, bind$0040_2.ConsumableReservations, bind$0040_2.ToolWithQuantityReservations, bind$0040_2.SetIds, bind$0040_2.ToolIds)), state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
        case 4:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_3 = state.Dto, new MultiReservationCreateDto(bind$0040_3.Description, msg.fields[0], bind$0040_3.StartDate, bind$0040_3.EndDate, bind$0040_3.NotifyUser, bind$0040_3.ReceiverId, bind$0040_3.ConsumableReservations, bind$0040_3.ToolWithQuantityReservations, bind$0040_3.SetIds, bind$0040_3.ToolIds)), state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
        case 1:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, msg.fields[0], state.EndDate), Cmd_none()];
        case 2:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, msg.fields[0]), Cmd_none()];
        case 8:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, (bind$0040_4 = state.Dto, new MultiReservationCreateDto(bind$0040_4.Description, bind$0040_4.Name, bind$0040_4.StartDate, bind$0040_4.EndDate, bind$0040_4.NotifyUser, defaultArg(map_1((v) => v.value.Id, msg.fields[0]), ""), bind$0040_4.ConsumableReservations, bind$0040_4.ToolWithQuantityReservations, bind$0040_4.SetIds, bind$0040_4.ToolIds)), state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
        case 9: {
            const id_2 = msg.fields[0];
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, cons(find((tableElement_2) => (tableElement_2.Id === id_2), state.RemovedElements), state.TableElements), filter((tableElement_3) => (tableElement_3.Id !== id_2), state.RemovedElements), state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
        }
        case 10: {
            const id_3 = msg.fields[0];
            const selectedElement_1 = find((tableElement_4) => (tableElement_4.Id === id_3), state.TableElements);
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, filter((tableElement_5) => (tableElement_5.Id !== id_3), state.TableElements), cons(selectedElement_1, state.RemovedElements), state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
        }
        case 18:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.Dto, msg.fields[0], state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
        case 16:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [msg.fields[0]]), state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), singleton_1((dispatch) => {
                dispatch(new Msg(11, []));
            })];
        case 17:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, new RequestedValue$1(1, [msg.fields[0]]), state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), singleton_1((dispatch_1) => {
                dispatch_1(new Msg(11, []));
            })];
        case 13:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, new RequestedValue$1(1, [msg.fields[0]]), state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), singleton_1((dispatch_2) => {
                dispatch_2(new Msg(11, []));
            })];
        case 14:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, new RequestedValue$1(1, [msg.fields[0]]), state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), singleton_1((dispatch_3) => {
                dispatch_3(new Msg(11, []));
            })];
        case 15:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, new RequestedValue$1(1, [msg.fields[0]]), state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), singleton_1((dispatch_4) => {
                dispatch_4(new Msg(11, []));
            })];
        case 11: {
            const matchValue = state.Consumables;
            const matchValue_1 = state.Tools;
            const matchValue_2 = state.Sets;
            const matchValue_3 = state.Storages;
            const matchValue_4 = state.Receivers;
            let matchResult, consumables, receivers, sets, storages, tools;
            if (matchValue.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_2.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_3.tag === 0) {
                matchResult = 1;
            }
            else if (matchValue_4.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                consumables = matchValue.fields[0];
                receivers = matchValue_4.fields[0];
                sets = matchValue_2.fields[0];
                storages = matchValue_3.fields[0];
                tools = matchValue_1.fields[0];
            }
            switch (matchResult) {
                case 0: {
                    const storageIds = map((storage) => storage.Id, storages);
                    const getStorageId = (storageId) => map_1((storage_2) => unwrapStorageId(storage_2.Id), tryFind((storage_1) => equals(storage_1.Id, storageId), storages));
                    const setElements = map((set$) => (new TableElement(newGuid(), set$.Id, set$.MasterData.Manufacturer, set$.MasterData.Model, set$.MasterData.Name, "", set$.MasterData.InventoryNumber, undefined, new TableElementType(3, []), "piece", getStorageId(new StorageId(parse(set$.LocationInformation.StorageId))), empty())), sets);
                    const toolElements = map((tool) => {
                        if (tool.tag === 1) {
                            const tool_2 = tool.fields[0];
                            const availableStorageIds = map((sps_1) => unwrapStorageId(sps_1.StorageId), filter((sps) => contains(sps.StorageId, storageIds, {
                                Equals: equals,
                                GetHashCode: (x_1) => (safeHash(x_1) | 0),
                            }), tool_2.StockPerStorage));
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_2.Id), tool_2.Manufacturer, tool_2.Model, tool_2.DisplayName, "", tool_2.InventoryNumber, 0, new TableElementType(1, []), "piece", tryHead(availableStorageIds), availableStorageIds);
                        }
                        else {
                            const tool_1 = tool.fields[0];
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_1.Id), tool_1.Manufacturer, tool_1.Model, tool_1.DisplayName, "", tool_1.InventoryNumber, undefined, new TableElementType(0, []), "piece", getStorageId(tool_1.StorageId), empty());
                        }
                    }, tools);
                    const consumableElements = map((consumable) => {
                        const availableStorageIds_1 = map((sps_3) => unwrapStorageId(sps_3.StorageId), filter((sps_2) => contains(sps_2.StorageId, storageIds, {
                            Equals: equals,
                            GetHashCode: (x_2) => (safeHash(x_2) | 0),
                        }), consumable.StockPerStorage));
                        return new TableElement(newGuid(), unwrapConsumableId(consumable.Id), "", "", consumable.Name, consumable.AdditionalName, consumable.InventoryNumber, 0, new TableElementType(2, []), consumable.Unit, tryHead(availableStorageIds_1), availableStorageIds_1);
                    }, consumables);
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, new RequestedValue$1(1, [(matchValue_6 = state.UserData.Role, (matchValue_6 === "system") ? receivers : ((matchValue_6 === "toolManager") ? receivers : ((matchValue_6 === "user") ? ((ownReceiver = (state.CustomerConfiguration.IsSelfServiceReservationForUserActive ? filter((receiver) => (receiver.Id === state.UserData.UserId), receivers) : empty()), append_1(filter((receiver_1) => {
                        const matchValue_7 = receiver_1.ReceiverType;
                        switch (matchValue_7.tag) {
                            case 8:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.SchoolClasses;
                            case 7:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.Students;
                            case 6:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.ConstructionSites;
                            case 5:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.Projects;
                            case 0:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.Users;
                            case 9:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.Vehicles;
                            case 3:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.Subcontractos;
                            case 2:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.ExternalPersons;
                            case 4:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.Rooms;
                            case 10:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.ApiReceivers;
                            default:
                                return state.CustomerConfiguration.ReceiverCreateReservationAllowedConfiguration.Employees;
                        }
                    }, receivers), ownReceiver))) : receivers)))]), state.Sets, state.Consumables, state.Storages, state.Tools, append_1(setElements, append_1(toolElements, consumableElements)), state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 19:
            return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_none()];
        default: {
            let updatedDto;
            const bind$0040 = state.Dto;
            const StartDate = toISOString(state.StartDate);
            const EndDate = toISOString(state.EndDate);
            const ToolIds = map((element_1) => element_1.ElementId, filter((element) => equals(element.Type, new TableElementType(0, [])), state.TableElements));
            const SetIds = map((element_3) => element_3.ElementId, filter((element_2) => equals(element_2.Type, new TableElementType(3, [])), state.TableElements));
            updatedDto = (new MultiReservationCreateDto(bind$0040.Description, bind$0040.Name, StartDate, EndDate, bind$0040.NotifyUser, bind$0040.ReceiverId, map((element_5) => {
                const Quantity = defaultArg(element_5.Quanity, 0);
                return new ConsumableReservation(element_5.ElementId, defaultArg(element_5.SelectedStorageId, ""), Quantity);
            }, filter((element_4) => equals(element_4.Type, new TableElementType(2, [])), state.TableElements)), map((element_7) => {
                const Quantity_1 = defaultArg(map_1((value_2) => (~~value_2 | 0), element_7.Quanity), 0) | 0;
                return new ToolWithQuantityReservation(element_7.ElementId, defaultArg(element_7.SelectedStorageId, ""), Quantity_1);
            }, filter((element_6) => equals(element_6.Type, new TableElementType(1, [])), state.TableElements)), SetIds, ToolIds));
            return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.Dto, state.NameSuggestions, state.CustomerConfiguration, state.UserData, state.StartDate, state.EndDate), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix_1(tupledArg[0]), (refreshOn) => fetchWithDecoder_1(url_2, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/multi-operations/reservation", toString(0, Auto_generateBoxedEncoder_437914C6(MultiReservationCreateDto_$reflection(), undefined, undefined, undefined)(updatedDto))], (Item) => (new Msg(12, [Item])), (Item_1) => (new Msg(19, [Item_1])))];
        }
    }
}

function Table(props) {
    let elems_1;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18n = patternInput[1];
    const containsConsumables = exists((tableElement) => equals(tableElement.Type, new TableElementType(2, [])), props.TableElements);
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const columnDefinition = toArray(delay(() => append(!FSharpMap__get_IsEmpty(props.FormState.Validations) ? singleton(new ColumnDefinition$1("hint", "", t("assign_multiple_tools_dialog.hint"), (row) => {
        let matchValue;
        const matchValue_1 = FormState__getValidation(props.FormState, t, concat((matchValue = row.Type, (matchValue.tag === 0) ? "tool" : ((matchValue.tag === 1) ? "tool-with-quantity" : ((matchValue.tag === 3) ? "set" : "consumable"))), "-", ...row.ElementId));
        if (matchValue_1 != null) {
            const value = matchValue_1;
            return new CellContent(1, [createElement(InvalidTextValue, {
                TestId: concat(row.Id, ..."-validation.reservation.reservation_exists_for_daterange"),
                Text: value,
            })]);
        }
        else {
            return new CellContent(0, [""]);
        }
    }, "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("assign_multiple_tools_dialog.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("assign_multiple_tools_dialog.model"), (row_2) => (new CellContent(0, [row_2.Model])), "none", "text")), delay(() => append(containsConsumables ? singleton(new ColumnDefinition$1("additionalName", "", t("consumable.additional_name"), (row_3) => (new CellContent(0, [row_3.AdditionalName])), "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("tool.displayname"), (row_4) => (new CellContent(0, [row_4.Name])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("assign_multiple_tools_dialog.inventory_number"), (row_5) => (new CellContent(0, [row_5.InventoryNumber])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_6) => {
        let Value_1, matchValue_4, Value, matchValue_3;
        const matchValue_2 = row_6.Type;
        switch (matchValue_2.tag) {
            case 1:
                return new CellContent(1, [createElement(NumberInput, (Value_1 = map_1((value_4) => value_4, row_6.Quanity), {
                    ComponentState: componentState,
                    MaxValue: numberInputIntMaxValue,
                    OnChange: (value_6) => {
                        props.Dispatch(new Msg(6, [row_6.Id, value_6]));
                    },
                    TestId: "",
                    ValidationMessage: unwrap((matchValue_4 = FormState__getValidation(props.FormState, t, concat("tool-with-quantity-", ...row_6.ElementId)), (matchValue_4 != null) ? matchValue_4 : undefined)),
                    Value: unwrap(Value_1),
                }))]);
            case 0:
            case 3:
                return new CellContent(0, ["1"]);
            default:
                return new CellContent(1, [createElement(NumberInput, (Value = map_1((value_1) => value_1, row_6.Quanity), {
                    ComponentState: componentState,
                    OnChange: (value_3) => {
                        props.Dispatch(new Msg(6, [row_6.Id, value_3]));
                    },
                    TestId: "",
                    ValidationMessage: unwrap((matchValue_3 = FormState__getValidation(props.FormState, t, concat("consumable-", ...row_6.ElementId)), (matchValue_3 != null) ? matchValue_3 : undefined)),
                    Value: unwrap(Value),
                }))]);
        }
    }, "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("unit", "", t("general.unit"), (row_7) => (new CellContent(0, [t(Helper_unitToTranslationKey(row_7.Unit))])), "none", "text")), delay(() => singleton(new ColumnDefinition$1("storage", "", t("general.storage"), (row_8) => {
        let selectedStorage;
        const matchValue_5 = row_8.SelectedStorageId;
        if (matchValue_5 == null) {
            selectedStorage = undefined;
        }
        else {
            const storageId = matchValue_5;
            selectedStorage = map_1((storage_1) => ({
                label: storage_1.Name,
                value: storage_1,
            }), tryFind((storage) => equals(storage.Id, new StorageId(parse(storageId))), props.Storages));
        }
        return new CellContent(1, [createElement(Select, {
            ComponentState: componentState,
            IsClearable: false,
            NoOptionsMessage: "select.storage_no_options",
            OnChange: (value_8) => {
                props.Dispatch(new Msg(7, [row_8.Id, map_1((value_9) => unwrapStorageId(value_9.value.Id), value_8)]));
            },
            Options: map((storage_3) => ({
                label: storage_3.Name,
                value: storage_3,
            }), filter((storage_2) => contains(unwrapStorageId(storage_2.Id), row_8.AvailableStorageIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }), props.Storages)),
            PlaceholderKey: "select.storage_placeholder",
            TestId: "",
            Value: unwrap(selectedStorage),
        })]);
    }, "none", "text"))))))))))))))))))));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_1 = toList(delay(() => {
        let elems, arg_1, arg_3;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "mb-4"])], (elems = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: props.IsAddedElementTabVisible,
                Label: containsConsumables ? t("assign_multiple_tools_dialog.consumables") : t("assign_multiple_tools_dialog.tools"),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(true);
                },
                TestId: "",
            }, {
                IsSelected: !props.IsAddedElementTabVisible,
                Label: containsConsumables ? ((arg_1 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, i18n.t("assign_multiple_tools_dialog.removed_consumables_elements", arg_1))) : ((arg_3 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, i18n.t("assign_multiple_tools_dialog.removed_elements", arg_3))),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(false);
                },
                TestId: "",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let TableRows, Options, TableRows_1, Options_1;
            return props.IsAddedElementTabVisible ? singleton(createElement(Table_1, (TableRows = toArray_1(props.TableElements), (Options = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["manufacturer", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "singleRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: columnDefinition,
                Controls: singleton_1(new TableControl$1(t("general.remove"), Recycle_Bin_1(), (rows) => {
                    iterate((row_10) => {
                        props.Dispatch(new Msg(10, [row_10]));
                    }, toArray_2(map_1((row_9) => row_9.Id, tryHead(rows))));
                }, true, false, "tools-dialog-toolreservation-dialog-remove-button")),
                Options: Options,
                TableKey: "not-defined-table",
                TableRows: TableRows,
            })))) : singleton(createElement(Table_1, (TableRows_1 = toArray_1(props.RemovedElements), (Options_1 = {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["manufacturer", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "singleRow",
                SaveTableConfiguration: false,
            }, {
                ColumnDefinitions: columnDefinition,
                Controls: singleton_1(new TableControl$1(t("general.remove"), Recycle_Bin_1(), (rows_1) => {
                    iterate((row_12) => {
                        props.Dispatch(new Msg(9, [row_12]));
                    }, toArray_2(map_1((row_11) => row_11.Id, tryHead(rows_1))));
                }, true, false, "tools-dialog-toolreservation-dialog-remove-button")),
                Options: Options_1,
                TableKey: "not-defined-table",
                TableRows: TableRows_1,
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Form(props) {
    let elems_3, children, elems, elems_1, elems_2, Label_5;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4", "mt-4", "w-96"])], (elems_3 = [createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
        ComponentState: componentState,
        IsClearable: false,
        Key: "select-user",
        Label: t("general.user"),
        NoOptionsMessage: "select.employee_no_options",
        OnChange: (value_1) => {
            props.Dispatch(new Msg(8, [value_1]));
        },
        Options: map((tupledArg) => {
            const receiverType = tupledArg[0];
            const receivers_1 = toArray_1(sortBy((receiver_2) => receiver_2.label.toLowerCase(), map((receiver_1) => {
                const matchValue = receiver_1.LocationName;
                if (matchValue != null) {
                    const locationName = matchValue;
                    if (equals(receiverType, new ReceiverTypeName(4, []))) {
                        return {
                            label: concat(locationName, " - ", ...receiver_1.Name),
                            value: receiver_1,
                        };
                    }
                    else {
                        return {
                            label: concat(receiver_1.Name, " - ", ...locationName),
                            value: receiver_1,
                        };
                    }
                }
                else {
                    return {
                        label: receiver_1.Name,
                        value: receiver_1,
                    };
                }
            }, tupledArg[1]), {
                Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
            }));
            return {
                label: Helper_receiverTypeNameTranslation(t, receiverType),
                options: receivers_1,
            };
        }, List_groupBy((receiver) => receiver.ReceiverType, props.Receivers, {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        })),
        PlaceholderKey: "select.employee_placeholder",
        Value: unwrap(map_1((receiver_4) => ({
            label: receiver_4.Name,
            value: receiver_4,
        }), tryFind((receiver_3) => (receiver_3.Id === props.Dto.ReceiverId), props.Receivers))),
    })), (children = ofArray([createElement(InformationAlert, {
        Label: t("tool.reservation_dialog.reservation_name_tooltip"),
    }), createElement(AutoSuggestInput, {
        ComponentState: componentState,
        Label: t("general.name"),
        OnChange: (value_2) => {
            props.Dispatch(new Msg(4, [value_2]));
        },
        Suggestions: props.NameSuggestions,
        TestId: "",
        ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "name")),
        Value: props.Dto.Name,
    })]), reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), reactElement("div", createObj(singleton_1((elems = [createElement(DatePicker, {
        ComponentState: componentState,
        IsClearable: false,
        Label: t("general.start_date"),
        OnChange: (date) => {
            if (date == null) {
            }
            else {
                const date_1 = date;
                if (compare(date_1, props.EndDate) > 0) {
                    props.Dispatch(new Msg(2, [date_1]));
                }
                props.Dispatch(new Msg(1, [date_1]));
            }
        },
        TestId: "",
        Value: props.StartDate,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])))), reactElement("div", createObj(singleton_1((elems_1 = [createElement(DatePicker, {
        ComponentState: componentState,
        IsClearable: false,
        Label: t("general.end_date"),
        MinDate: props.StartDate,
        OnChange: (date_2) => {
            if (date_2 == null) {
            }
            else {
                props.Dispatch(new Msg(2, [date_2]));
            }
        },
        TestId: "",
        Value: props.EndDate,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])))), createElement(TextArea, {
        ComponentState: componentState,
        Label: t("general.description"),
        OnChange: (value_5) => {
            props.Dispatch(new Msg(5, [value_5]));
        },
        TestId: "",
        Value: props.Dto.Description,
    }), reactElement("div", createObj(singleton_1((elems_2 = [createElement(Button, (Label_5 = t("general.save"), {
        ComponentState: (componentState === "disabled") ? "disabled" : ((((props.Dto.ReceiverId === "") ? true : props.IsTableElementsEmpty) ? true : props.HasTableElementEmptyStorageId) ? "disabled" : "enabled"),
        Label: Label_5,
        OnClick: () => {
            props.Dispatch(new Msg(0, []));
        },
        TestId: "tools-dialog-toolreservation-save-button",
        Variant: "primary",
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function Content(props) {
    let elems_2, elems_1;
    const patternInput = useTranslation();
    const patternInput_1 = reactApi.useState(true);
    const isAddedElementsTabSelected = patternInput_1[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["min-h-48"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4"])], (elems_1 = toList(delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(Table, {
            Dispatch: props.Dispatch,
            FormState: props.FormState,
            IsAddedElementTabVisible: isAddedElementsTabSelected,
            RemovedElements: props.RemovedElements,
            SetIsAddedElementTabVisible: patternInput_1[1],
            Storages: props.Storages,
            TableElements: props.TableElements,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let IsTableElementsEmpty;
            return isAddedElementsTabSelected ? singleton(createElement(Form, (IsTableElementsEmpty = isEmpty(props.TableElements), {
                Dispatch: props.Dispatch,
                Dto: props.Dto,
                EndDate: props.EndDate,
                FormState: props.FormState,
                HasTableElementEmptyStorageId: exists((tableElement) => (tableElement.SelectedStorageId == null), props.TableElements),
                IsTableElementsEmpty: IsTableElementsEmpty,
                NameSuggestions: props.NameSuggestions,
                Receivers: props.Receivers,
                StartDate: props.StartDate,
            }))) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function MultiReservationModalSheet(props) {
    let elems, matchValue, matchValue_1, matchValue_2, matchValue_3, matchValue_4;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.SuccessCallback, props.OnClose, props.UserData, props.CustomerConfiguration, props.ReservationProps), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput[0];
    const patternInput_1 = useTranslation();
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue = state_1.Receivers, (matchValue_1 = state_1.Consumables, (matchValue_2 = state_1.Sets, (matchValue_3 = state_1.Tools, (matchValue_4 = state_1.Storages, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_1.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_2.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_3.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_4.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            Dispatch: patternInput[1],
            Dto: state_1.Dto,
            EndDate: state_1.EndDate,
            FormState: state_1.FormState,
            NameSuggestions: state_1.NameSuggestions,
            Receivers: matchValue.fields[0],
            RemovedElements: state_1.RemovedElements,
            StartDate: state_1.StartDate,
            Storages: matchValue_4.fields[0],
            TableElements: state_1.TableElements,
        })))))))))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput_1[0]("general.reserve"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

